import type { ReactNode } from 'react'
import { ToastProvider } from './ToastProvider'
import { ConfirmProvider } from './ConfirmDialog'

export interface UiPrimitivesProviderProps {
  children: ReactNode
}

/**
 * Convenience wrapper that mounts every UI-primitive provider the PWA
 * needs as a single drop-in component. Order matters: `<ConfirmProvider>`
 * is inside `<ToastProvider>` so confirmation handlers can fire toasts.
 */
export function UiPrimitivesProvider({ children }: UiPrimitivesProviderProps) {
  return (
    <ToastProvider>
      <ConfirmProvider>{children}</ConfirmProvider>
    </ToastProvider>
  )
}

export default UiPrimitivesProvider
